import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const Container: React.FunctionComponent = ({ children }) => {
  const { paymentContainer } = useStyles();

  return <div className={paymentContainer}>{children}</div>;
};

const useStyles = makeStyles<Theme>((theme) => ({
  paymentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    alignSelf: 'center',
    width: '100%',
    maxWidth: 960,
    padding: '40px 0px',
    [theme.breakpoints.down('md')]: {
      maxWidth: 600,
      padding: '32px 16px 88px 16px'
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%'
    }
  }
}));

export default Container;
